var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.classList.concat(['flex','justify-between','justify-items-center','pr-8'])},[_c('p',[_vm._v(_vm._s(_vm.name))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }